import { useMemo } from 'react';
import { prefersReducedMotion } from '../../lib/motion';

const COLORS = ['#B3261E', '#F2B33D', '#3F7D3A', '#F4511E', '#B3261E', '#FCD26B'];

/** #14 Check animado + confeti ligero de «pepperonis» (< 1.5 s; sin confeti con reduced-motion). */
export function OrderSuccess({ title = '¡Pedido recibido!', subtitle }) {
  const bits = useMemo(() => {
    if (prefersReducedMotion()) return [];
    return Array.from({ length: 22 }, (_, i) => {
      const ang = (i / 22) * Math.PI * 2 + Math.random() * 0.4;
      const dist = 90 + Math.random() * 90;
      return {
        x: `${Math.cos(ang) * dist}px`,
        y: `${Math.sin(ang) * dist - 30}px`,
        r: `${Math.round(Math.random() * 540)}deg`,
        c: COLORS[i % COLORS.length],
        s: 8 + Math.round(Math.random() * 8),
        d: `${Math.random() * 0.15}s`,
      };
    });
  }, []);
  return (
    <div className="relative text-center py-4" role="status" aria-live="polite">
      <svg className="t-check w-24 h-24 mx-auto" viewBox="0 0 52 52" aria-hidden="true">
        <circle cx="26" cy="26" r="24" fill="#3F7D3A" stroke="#2D5E2A" strokeWidth="3" />
        <path d="M15 27 l7 7 l15 -16" fill="none" stroke="#FFFDF8" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {bits.map((b, i) => (
        <span
          key={i}
          className="t-confetti"
          style={{ '--x': b.x, '--y': b.y, '--r': b.r, '--delay': b.d, background: b.c, width: b.s, height: b.s }}
          aria-hidden="true"
        />
      ))}
      <p className="font-heading text-3xl font-extrabold mt-3">{title}</p>
      {subtitle ? <p className="text-[#6B5444] mt-1">{subtitle}</p> : null}
    </div>
  );
}

/** Seguimiento simple por estados (solo lectura del estado que ya devuelve el pedido). */
export function OrderTracker({ status, deliveryType }) {
  const pickup = deliveryType === 'pickup';
  const steps = ['Recibido', 'En el horno', pickup ? 'Listo para recoger' : 'En camino', 'Entregado'];
  const st = String(status || '').toLowerCase();
  let idx = 0;
  if (['accepted', 'preparing', 'awaiting_extras'].includes(st)) idx = 1;
  else if (st === 'ready') idx = pickup ? 2 : 1;
  else if (st === 'dispatched') idx = 2;
  else if (st === 'delivered') idx = 3;
  const pct = (idx / (steps.length - 1)) * 100;
  return (
    <div className="my-5" aria-label={`Estado del pedido: ${steps[idx]}`}>
      <div className="relative h-2 rounded-full bg-[#F1DFC8] overflow-hidden">
        <div className="t-track-fill absolute inset-y-0 left-0 rounded-full bg-[#3F7D3A]" style={{ width: `${pct}%` }} />
      </div>
      <ol className="mt-3 grid grid-cols-4 text-xs sm:text-sm font-semibold text-center">
        {steps.map((s, i) => (
          <li key={s} className={i <= idx ? 'text-[#2B1A12]' : 'text-[#6B5444]/80'} aria-current={i === idx ? 'step' : undefined}>
            <span
              className={`mx-auto mb-1 block w-3 h-3 rounded-full ${i <= idx ? 'bg-[#3F7D3A]' : 'bg-[#F1DFC8]'} ${i === idx ? 'ring-4 ring-[#3F7D3A]/25' : ''}`}
              aria-hidden="true"
            />
            {s}
          </li>
        ))}
      </ol>
    </div>
  );
}
